import { chainList, defaultNetwork, defaultChain, polygonNetWork } from './chainConfUtil'

const configChainList = chainList()

/**
 * @description: 判断当前链id 平台是否支持
 * @param {Number} chainId
 * @return {Boolean}
 */
export function isAppSupportedChainId(chainId) {
  const flag = configChainList.some((item) => item.chainId == chainId)
  return flag
}

/**
 * @description: 判断当前网络 平台是否支持
 * @param {Number} networkId
 * @return {Boolean}
 */
export function isAppSupportedNetworkId(networkId) {
  const flag = configChainList.some((item) => item.networkId == networkId)
  return flag
}

/**
 * @description: 判断当前链是不是平台主网络
 * @return {Number}
 */
export function isMainNetwork(networkId) {
  if (networkId) {
    const networkItem = defaultNetwork()
    return networkItem.networkId == networkId
  }
  return false
}

/**
 * @description: 判断当前链是不是平台主链
 * @return {Number}
 */
export function isMainChain(chainId) {
  if (chainId) {
    const chainItem = defaultChain()
    return chainItem.chainId == chainId
  }
  return false
}

/**
 * @description: 判断当前链是不是平台主网络
 * @return {Number}
 */
export function isPolygonNetwork(networkId) {
  if (networkId) {
    const networkItem = polygonNetWork()
    return networkItem.networkId == networkId
  }
  return false
}

/**
 * @description: 地址简单显示（ 正式环境和测试环境通用 ）
 * @param {Number} address 16进制的地址
 * @param {Number} limitLength
 * @return {String}
 */
export function showShortAddress(address, limitLength = 40) {
  if (address) {
    if (address.startsWith('0x') || address.length >= limitLength) {
      address = address ? address.slice(0, 6) + '...' + address.substr(address.length - 4, 4) : ''
    }
  }

  return address
}
